import React, { useState } from "react";
import "./weatherapp.css";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import Forecast from "./Forcast";

export default function WeatherApp(props) {
  const [city, setCity] = useState(props.defaultCity);
  const [weatherInfo, setWeatherInfo] = useState({ loaded: false });

  function displayInfo(response) {
    setWeatherInfo({
      loaded: true,
      placename: response.data.city,
      temperature: Math.round(response.data.temperature.current),
      wind: Math.round(response.data.wind.speed),
      date: new Date(response.data.time * 1000),
      humidity: response.data.temperature.humidity,
      description: response.data.condition.description,
      icon: response.data.condition.icon_url,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }
  function handleSearch(event) {
    setCity(event.target.value);
  }
  function search() {
    let apiKey = "fab80702t0ae63d380b14ab9a413do4f";
    let units = "metric";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units${units}`;
    axios.get(apiUrl).then(displayInfo);
  }
  if (weatherInfo.loaded) {
    return (
      <div className="weatherApp">
        <div>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-8">
                <input
                  type="text"
                  placeholder="Type a city..."
                  id="city"
                  autoFocus="on"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-4">
                <input
                  type="submit"
                  value="Search"
                  className="btn btn-primary"
                  id="search-button"
                />
              </div>
            </div>
          </form>
        </div>
        <WeatherInfo info={weatherInfo} />
        <hr />
        <Forecast info={weatherInfo} />
      </div>
    );
  } else {
    search();
    return "loading...";
  }
}
